/**
 * Clearing the tenant-scoped things this browser remembers.
 *
 * Lives apart from the two stores so the logout paths have one call to make and
 * no cycle back into the React contexts.
 */

import { forgetStoredTenant } from '@/context/tenant-context';
import { forgetTenantRegions } from '@/lib/tenant-region-hints';

/**
 * Called on sign-out. On a shared clinical workstation the next user must not
 * inherit the previous user's selected organization or region hints — the hints
 * in particular would make their registry query a region they have nothing in,
 * creating a user record there for no reason.
 */
export function forgetTenantScopedStorage(): void {
    forgetStoredTenant();
    forgetTenantRegions();
}
